import { createApp } from '@app/adapters/create-app'
import ShareTrigger from '@app/application/pulse-share/share-trigger-mode.vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='share-trigger-mode']"
  ) as HTMLElement

  if (element) {
    const { ledgerId, objectId, isBlockedInitial, sharedObjectName, mode } =
      element.dataset

    createApp(ShareTrigger, {
      ledgerId: Number(ledgerId),
      objectId: Number(objectId),
      isBlockedInitial: isBlockedInitial === 'true',
      sharedObjectName,
      mode,
    }).mount(element)
  }
})
